import React, { useState, useEffect } from "react";
import { Image } from "../../components/componentIndex";

const RadioButton = ({ radioButton, name, id, onRadioChange, formData, imgUrl, activeIcon, value,  setValue }) => {
    // const [selectedRadio, setSelectedRadio] = useState(formData?.sex || null);

    useEffect(() => {
        if (value) {
            setValue(value);
        }else{
            if(formData && formData !== ''){
                setValue(formData);
            }
        }
    }, []);

    const handleChange = () => {
        setValue(name);
        // formData.sex = name;
        onRadioChange(name); // Sending the name (or any other value) to the parent
    };
    return (
        <>
            <div className="form-check">

                <input className={`form-check-input ${value === name ? 'selected' : ''}`} type="radio" name={radioButton} id={`${name}-${id}`} checked={value === name} onChange={handleChange} />
                <label className={`form-check-label ${value === name ? 'checked' : ''}`} htmlFor={`${name}-${id}`} >
                    {imgUrl && (
                        <Image imgUrl={value === name ? activeIcon : imgUrl } altText={''} className={''} />
                    )
                    }
                    {name}
                </label>
            </div>
        </>
    );
};

export default RadioButton;